import { DEFAULT_AVATAR } from '../../constants/repositories';
import BaseEntity from './BaseEntity';
import CommitCodeCoverage from './CommitCodeCoverage';
import CommitSimple from './CommitSimple';
import User from './User';
export default class PullRequest extends BaseEntity {
    constructor(data) {
        super();
        this.mergeTime = 0;
        this.reviewTime = 0;
        this.sourceCommit = null;
        this.user = null;
        this.workInProgressTime = 0;
        this.description = this.parseProperty(data, 'description');
        this.errorCount = this.parseProperty(data, 'errorCount');
        this.errorDiff = this.parseProperty(data, 'errorDiff');
        this.id = this.parseProperty(data, 'id');
        this.isOpen = this.parseProperty(data, 'isOpen');
        this.mergeTime = this.parseProperty(data, 'mergeTime');
        this.prId = this.parseProperty(data, 'prId');
        this.prUpdatedOn = this.parseProperty(data, 'prUpdatedOn');
        this.repositoryId = this.parseProperty(data, 'repositoryId');
        this.reviewTime = this.parseProperty(data, 'reviewTime');
        this.title = this.parseProperty(data, 'title');
        this.updatedAt = this.parseProperty(data, 'updatedAt');
        this.warningCount = this.parseProperty(data, 'warningCount');
        this.warningDiff = this.parseProperty(data, 'warningDiff');
        this.workInProgressTime = this.parseProperty(data, 'workInProgressTime');
        this.destinationBranchName = data.destinationBranch?.name;
        this.sourceBranchName = data.sourceCommit?.branch.name;
        if (data.sourceCommit) {
            this.sourceCommit = new CommitSimple(data.sourceCommit, {}, data.codeCoverage ? new CommitCodeCoverage(data.codeCoverage) : void 0);
        }
        // Note: I'm not expecting to be user null, this just handle the unknown situations and will be removed
        if (data.user) {
            this.user = new User(data.user);
        }
    }
    getIssuesCount() {
        return this.errorCount + this.warningCount;
    }
    getDiffCount() {
        return this.errorDiff + this.warningDiff;
    }
    getUserAvatar() {
        if (this.user) {
            return this.user.bitbucketAvatar ?? this.user.gitlabAvatar ?? DEFAULT_AVATAR;
        }
        return DEFAULT_AVATAR;
    }
    getCycleTime() {
        return this.workInProgressTime + this.reviewTime + this.mergeTime;
    }
}
